"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Textarea = Textarea;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function Textarea(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("textarea", {
    name: name,
    value: value,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange,
    className: className
  });
}

Textarea.propTypes = {
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var _default = Textarea;
exports["default"] = _default;